var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-main',[_c('v-container',{attrs:{"fluid":""}},[_c('v-row',{attrs:{"justify":"start"}},[_c('div',{staticClass:"hello"},[_c('h1',[_vm._v("Служебные данные")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("\n            Версия: "+_vm._s(_vm.versions)+"\n          ")])])])])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-279c0950","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/internalComponents.vue
// module id = null
// module chunks = 